// extracted by mini-css-extract-plugin
export var shake = "_g-0";